import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ImgStepFour from "../../../../../assets/Images/CarePlan4A.jpg";
import HabitModal from "../modals/AddHabitModal";

export default function Habits() {
  const { t } = useTranslation();
  const [habits, setHabits] = useState([]);
  const [openModal, setOpenModal] = useState(false);

  // Agregar hábito
  const handleSaveHabit = (newHabit) => {
    setHabits([...habits, newHabit]);
  };

  // Eliminar hábito
  const handleRemoveHabit = (id) => {
    setHabits(habits.filter((habit) => habit.id !== id));
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 3,
        overflow: "hidden",
        width: "100%",
      }}
    >
      {/* Header azul */}
      <Box
        sx={{
          backgroundColor: "#085394",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        {/* Título en recuadro blanco */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 1,
            px: 2,
            py: 1,
            display: "inline-block",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              color: "#085394",
              textTransform: "uppercase",
              m: 0,
            }}
          >
            {t("CarePlan.createCarePlanHdr.wizard.stepFour")}
          </Typography>
        </Box>

        {/* Imagen a la derecha */}
        <Box sx={{ ml: 2 }}>
          <img
            src={ImgStepFour}
            alt="Hábitos"
            style={{ width: "120px", borderRadius: "8px" }}
          />
        </Box>
      </Box>

      {/* Contenido principal (tabla y botón) */}
      <Box sx={{ p: 3 }}>
        <TableContainer component={Paper} sx={{ mb: 3, boxShadow: 3 }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#085394" }}>
              <TableRow>
              {["id", "habitDate", "habit", "status", "action"].map((key) => (
                  <TableCell key={key} sx={{ color: "#fff", fontWeight: "bold" }}>
                    {t(`CarePlan.habit.table.${key}`)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {habits.length > 0 ? (
                habits.map((habit) => (
                  <TableRow key={habit.id}>
                    <TableCell>{habit.id}</TableCell>
                    <TableCell>{habit.date}</TableCell>
                    <TableCell>{habit.name}</TableCell>
                    <TableCell>{habit.status}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => handleRemoveHabit(habit.id)}
                        sx={{
                          color: "red",
                          "&:hover": { backgroundColor: "#FFEBEE" },
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("CarePlan.habit.noRecords")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Botón para Agregar Hábito */}
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setOpenModal(true)}
          sx={{
            backgroundColor: "#085394",
            "&:hover": { backgroundColor: "#064372" },
          }}
        >
          {t("CarePlan.habit.addHabit")}
        </Button>

        {/* Modal de Hábitos */}
        <HabitModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          onSave={handleSaveHabit}
        />
      </Box>
    </Box>
  );
}
